import { render, staticRenderFns } from "./FormulaCriterion.vue?vue&type=template&id=7496bb2f"
import script from "./FormulaCriterion.vue?vue&type=script&lang=js"
export * from "./FormulaCriterion.vue?vue&type=script&lang=js"
import style0 from "./FormulaCriterion.vue?vue&type=style&index=0&id=7496bb2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports